import { render, staticRenderFns } from "./SectionInfoBaremeAjuste.vue?vue&type=template&id=8a3c2c72&scoped=true&"
import script from "./SectionInfoBaremeAjuste.vue?vue&type=script&lang=js&"
export * from "./SectionInfoBaremeAjuste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3c2c72",
  null
  
)

export default component.exports